import { Box, Button, useTheme, useMediaQuery } from '@mui/material';
import { getCategoryIcon } from '../utils/categoryUtils';
import { useRef, useEffect } from 'react';

function CategoryButtons({ categories, selectedCategory, onCategorySelect }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const scrollContainerRef = useRef(null);

  // Handle horizontal scroll with mouse wheel
  const handleWheel = (event) => {
    const container = scrollContainerRef.current;
    if (container) {
      event.preventDefault();
      container.scrollLeft += event.deltaY;
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    // Add wheel event listener
    container.addEventListener('wheel', handleWheel, { passive: false });

    // Cleanup
    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, []);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const selectedButton = container.children[selectedCategory];
    if (!selectedButton) return;

    const containerWidth = container.offsetWidth;
    const buttonOffsetLeft = selectedButton.offsetLeft;
    const buttonWidth = selectedButton.offsetWidth;

    // Calculate scroll position to center the button
    const scrollPosition = buttonOffsetLeft - (containerWidth / 2) + (buttonWidth / 2);

    container.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
  }, [selectedCategory]);

  return (
    <Box 
      ref={scrollContainerRef}
      sx={{ 
        p: 0,
        pt: 3,
        pb: 1,
        px: isMobile ? 2 : 6,
        display: 'flex',
        gap: 2,
        overflowX: 'auto',
        overflowY: 'hidden',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        background: theme => `linear-gradient(
          to bottom,
          ${theme.palette.primary.main} 50%,
          #f5f5f5 50%
        )`,
        height: 80,
        WebkitOverflowScrolling: 'touch',
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing'
        }
      }}
    >
      {categories.map((category, index) => (
        <Button
          key={category.value}
          onClick={() => onCategorySelect(index)}
          sx={{
            minWidth: 'auto',
            px: 3,
            py: 1,
            borderRadius: '12px',
            backgroundColor: selectedCategory === index ? 'primary.light' : 'white',
            color: selectedCategory === index ? 'primary.dark' : 'black',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            textTransform: 'none',
            whiteSpace: 'nowrap',
            fontFamily: 'Graphik Arabic',
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          {category.value !== 'all' && (
            <img 
              src={getCategoryIcon(category.value)} 
              alt="" 
              style={{ 
                width: 20, 
                height: 20 
              }} 
            />
          )}
          {category.label}
        </Button>
      ))}
    </Box>
  );
}

export default CategoryButtons;